import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/common/SEO";
import { Reveal } from "../components/common/Reveal";
import BlogCard from "../components/cards/BlogCard";
import CTASection from "../components/common/CTASection";
import { StaggerGroup } from "../components/common/Reveal";
import { getInsight, insights } from "../data/insights";

export default function InsightDetail() {
  const { slug } = useParams();
  const post = getInsight(slug);
  if (!post) return <Navigate to="/insights" replace />;

  const related = insights.filter((i) => i.slug !== slug && i.category === post.category).slice(0, 3);
  const fallback = insights.filter((i) => i.slug !== slug).slice(0, 3);
  const more = related.length ? related : fallback;

  return (
    <>
      <SEO title={post.title} description={post.excerpt} path={`/insights/${slug}`} />

      <article className="px-6 pt-40 lg:pt-48">
        <div className="mx-auto max-w-3xl">
          <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-slate-400 transition-colors hover:text-sky-400" data-testid="insight-back">
            <ArrowLeft className="h-4 w-4" /> All Insights
          </Link>
          <div className="mt-8 flex items-center gap-3 text-xs text-slate-500">
            <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 font-medium uppercase tracking-wide text-sky-400">{post.category}</span>
            <span>{post.date}</span>
            <span className="h-1 w-1 rounded-full bg-slate-600" />
            <span>{post.readTime}</span>
          </div>
          <h1 className="mt-5 font-heading text-4xl font-bold leading-[1.08] tracking-tighter text-white sm:text-5xl">
            {post.title}
          </h1>
          <p className="mt-5 text-sm text-slate-500">By {post.author}</p>
        </div>

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-2xl border border-white/10">
          <img src={post.image} alt={post.title} className="h-[280px] w-full object-cover sm:h-[420px]" />
        </div>

        <div className="mx-auto mt-12 max-w-3xl pb-8">
          {post.content.map((block, i) =>
            block.type === "h" ? (
              <Reveal key={i}>
                <h2 className="mt-10 font-heading text-2xl font-bold tracking-tight text-white">{block.text}</h2>
              </Reveal>
            ) : (
              <Reveal key={i}>
                <p className="mt-5 text-base leading-relaxed text-slate-300 lg:text-lg">{block.text}</p>
              </Reveal>
            )
          )}
        </div>
      </article>

      <section className="border-t border-white/5 px-6 py-20">
        <div className="mx-auto max-w-7xl">
          <h3 className="font-heading text-2xl font-bold tracking-tight text-white">More insights</h3>
          <StaggerGroup className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.06}>
            {more.map((p) => (
              <BlogCard key={p.slug} post={p} />
            ))}
          </StaggerGroup>
        </div>
      </section>

      <CTASection />
    </>
  );
}
